// extracted by mini-css-extract-plugin
module.exports = {"header":"Header--header--28-mG","container":"Header--container--1vkAS","content":"Header--content--3Z9YS","logo":"Header--logo--1qgNO"};